import { useEffect } from "react";
import sharedStyles from 'styles/css/SharedStyles.module.scss';
// import styles from 'styles/css/Main.module.scss';
// import drawerStyles from 'styles/css/Drawer.module.scss';
// import actionStyles from 'styles/css/ActionStyles.module.scss';
// import Logo from 'styles/images/logo/logo512.png';

import ShortHeaderWithBackBtn from 'components/root/partials/header/ShortHeaderWithBackBtn';
import formStyles from 'styles/css/FormStyles.module.scss';
import ruleStyles from 'styles/css/RuleStyles.module.scss';

const ContactUs = () => {

    const toPersianDigits = (num) => {
        return num.toString().replace(/\d/g, d => '۰۱۲۳۴۵۶۷۸۹'[d]);
    };

    useEffect(() => {
        // ایمیل ۱
        const e1p1 = "dr20consult";
        const e1p2 = "gmail.com";
        const e1 = `${e1p1}@${e1p2}`;
        const e1Entity = "&#100;&#114;&#50;&#48;&#99;&#111;&#110;&#115;&#117;&#108;&#116;&#64;&#103;&#109;&#97;&#105;&#108;&#46;&#99;&#111;&#109;";
        document.getElementById("email1").innerHTML =
            `<a href="mailto:${e1}">${e1Entity}</a>`;

        // ایمیل ۲
        // const e2p1 = "dr20consult";
        // const e2p2 = "iran.ir";
        // const e2 = `${e2p1}@${e2p2}`;
        // const e2Entity = "&#100;&#114;&#50;&#48;&#99;&#111;&#110;&#115;&#117;&#108;&#116;&#64;&#105;&#114;&#97;&#110;&#46;&#105;&#114;";
        // document.getElementById("email2").innerHTML =
        //     `<a href="mailto:${e2}">${e2Entity}</a>`;
    }, []);

    return (
        
        <div className={sharedStyles.container} id={ruleStyles['rules-page']}>

            <div className={[sharedStyles['container-padding'], sharedStyles['pb-[64px]']].join(' ')}>
                <ShortHeaderWithBackBtn />
                
                <p className={formStyles['text-center']}>
                    ارتباط با ما 
                </p>

                <p className={formStyles['text-center']}>
                    تلفن ها:
                    <br />
                    {/*<a href="tel:+987136364893">071-36364893</a>
                    <br />
                    (6 خط سانترال)*/}
                    <div className={[sharedStyles.flex, sharedStyles.justifyCenter].join(' ')}>
                        <div className={[sharedStyles.flex, sharedStyles['flex-col'], sharedStyles.itemsEnd, sharedStyles['w-fit']].join(' ')}>
                            {/*<span className={[sharedStyles['dir-ltr'], sharedStyles['w-full'], sharedStyles.flex, sharedStyles.justifyBetween, sharedStyles.gapLg].join(' ')}>
                                <a href="tel:35017">35017</a> <span className={sharedStyles['dir-rtl']}>({toPersianDigits("30")} خط تلفن ثابت)</span>
                            </span>
                            <a href="tel:+987136242214" >07136242214</a>*/}

                            <span className={[sharedStyles['dir-ltr'], sharedStyles['w-full'], sharedStyles.flex, sharedStyles.justifyBetween, sharedStyles.gapLg].join(' ')}>
                                <a href="tel:+987136242214">07136242214</a> <span className={sharedStyles['dir-rtl']}>({toPersianDigits("7")} خط سانترال)</span>
                            </span>
                        </div>
                    </div>
                </p>

                <p className={formStyles['text-center']}>
                    پشتیبانی:
                    <br />
                    {/*<a href="tel:+989020843320">09020843320</a>*/}
                    <a href="tel:+989171020676">09171020676 </a>
                </p>

                <p className={formStyles['text-center']}>
                    ایمیل مدیر عامل جهت ارتباط مستقیم:
                    <br />

                    <span id="email1"></span>
                    <br />
                    <span id="email2"></span>
                </p>

                <p className={formStyles['text-center']}>
                    آدرس سایت اصلی: 
                    <br />
                    www.Dr20.org
                </p>

                <p className={formStyles['text-center']}>
                    آدرس وب سایت های اکسسوری:
                    <br />
                    <a href="https://dr20.education" target="_blank">www.Dr20.education</a>
                    <br />
                    <a href="https://dr20.net" target="_blank">www.Dr20.net</a>
                    <br />
                    <a href="https://dr20.info" target="_blank">www.Dr20.info</a>
                    <br />
                    <a href="https://dr20.shop" target="_blank">www.Dr20.shop</a>
                    <br />
                    <a href="https://dr20.biz" target="_blank">www.Dr20.biz</a>
                    <br />
                    <a href="https://dr20.app" target="_blank">www.Dr20.app</a>
                </p>

                <p className={formStyles['text-center']}>
                    آدرس پیج اینستاگرام فارسی:
                    <br />
                    <a href="https://instagram.com/dr20_org" target="_blank">www.instagram.com/dr20_org</a>
                </p>

                <p className={formStyles['text-center']}>
                    آدرس پیج اینستاگرام بین‌الملل:
                    <br />
                    <a href="https://instagram.com/dr20_int" target="_blank">www.instagram.com/dr20_int</a>
                </p>

            </div>
                
        </div>

    );
}

export default ContactUs;